export let Genres;
(function (Genres) {
  Genres["ACTION"] = "action";
  Genres["ADVENTURE"] = "adventure";
  Genres["ANIMATION"] = "animation";
  Genres["AFRICAN"] = "african";
  Genres["AFRICAN_AMERICAN"] = "african-american";
  Genres["ASIAN"] = "asian";
  Genres["ASIAN_AMERICAN"] = "asian-american";
  Genres["BLACK"] = "black";
  Genres["BUDDHIST"] = "buddhist";
  Genres["BIOGRAPHY"] = "biography";
  Genres["CHILDREN"] = "children";
  Genres["CHRISTIAN"] = "christian";
  Genres["COMEDY"] = "comedy";
  Genres["CRIME"] = "crime";
  Genres["DIY"] = "diy";
  Genres["DEVELOPING_NATIONS"] = "developing-nations";
  Genres["DISABILITY_CULTURE"] = "disability-culture";
  Genres["DOCUMENTARY"] = "documentary";
  Genres["DRAMA"] = "drama";
  Genres["EDUCATION"] = "education";
  Genres["FAMILY"] = "family";
  Genres["FANTASY"] = "fantasy";
  Genres["FILM_NOIR"] = "film-noir";
  Genres["GAME_SHOW"] = "game-show";
  Genres["HISPANIC"] = "hispanic";
  Genres["HISTORY"] = "history";
  Genres["HORROR"] = "horror";
  Genres["INSTRUCTIONAL"] = "instructional";
  Genres["ISLAMIC"] = "islamic";
  Genres["JEWISH"] = "jewish";
  Genres["LGBTQ"] = "lgbtq";
  Genres["LATINO"] = "latino";
  Genres["MATURE_ADULT"] = "mature-adult";
  Genres["MUSIC"] = "music";
  Genres["MUSICAL"] = "musical";
  Genres["MYSTERY"] = "mystery";
  Genres["NEWS"] = "news";
  Genres["NATIVE_AMERICAN"] = "native-american";
  Genres["NATIVE_ABORIGINAL_PEOPLE"] = "native-aboriginal-people";
  Genres["PERSONAL"] = "personal";
  Genres["REALITY_TV"] = "reality-tv";
  Genres["ROMANCE"] = "romance";
  Genres["SCI_FI"] = "sci-fi";
  Genres["SENIOR_AGING"] = "senior-aging";
  Genres["SPORT"] = "sport";
  Genres["STUDENT"] = "student";
  Genres["TALK_SHOW"] = "talk-show";
  Genres["THRILLER"] = "thriller";
  Genres["WAR"] = "war";
  Genres["WESTERN"] = "western";
  Genres["WOMEN"] = "women";
  Genres["YOUTH_TEEN"] = "youth-teen";
})(Genres || (Genres = {}));
//# sourceMappingURL=genres.js.map